export const enum PaymentSystem {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Mir = 'mir',
  Maestro = 'maestro',
  Corp = 'corp',
}

export const PAYMENT_SYSTEMS: Readonly<Array<PaymentSystem>> = [
  PaymentSystem.Visa,
  PaymentSystem.Mastercard,
  PaymentSystem.Mir,
  PaymentSystem.Corp,
  PaymentSystem.Maestro,
]
